
var
    Base = require('views/_BaseView'),
    scope = require('scope'),
    metrics = require('../lib/metrics'),
    InternalError = require('./Error'),
    first = true,
    Layout =  Base.extend({
        template: require('templates/layouts/base.hbs'),
        name: 'layout',
        events: {
        },
        behaviors: {
        },
        partials: {
            content: {
                region: '#cotacao-content'
            }
        },
        initialize: function () {
            var self = this;
            var last = null;

            self.getRegion('content').on('show', function (layout, view) {
                !first && $(scope.app.$el).addClass('cotacao-page-changed');
                $(scope.app.$el).removeClass(last).addClass(last = view.name);

                setTimeout(function () {
                    first = false;
                    metrics.initSections();
                    $(scope.app.$el).removeClass('cotacao-page-changed');

                    $(scope.app.$el).removeClass('cotacao-loading');
                }, 500);
            });
        },
        go: function (view, cb) {
            var self = this;

            scope.metrics.stopScroll();

            self.partials.content.instance = view;

            $(scope.app.$el).addClass('cotacao-loading');

            self.load().done(function(response){
                console.log("ALL LOAD COMPLETE");
                
                self.populate();
                scope.app.started = true;

                scope.metrics.resumeScroll();
                
                cb && cb();
            }).catch(function(e){
                if(self.partials.content.instance.checkauth){
                    window.location = './';
                    return;
                }

                self.partials.content.instance = new InternalError({
                    data: {
                        message: "Ops, houve um erro inesperado, por favor tente novamente mais tarde."
                    }
                });
                self.populate();
                
                scope.metrics.resumeScroll();
                
                cb && cb();
            });
        }
    });

module.exports = Layout;



// WEBPACK FOOTER //
// ./resources/scripts/views/_Layout.js